<template>
  <vs-select
    v-if="show"
    @dataChanged="onDataChanged"
    dir="rtl"
    :data="voucherTypes"
    :header-key="headerKey"
    :mode="_mode"
    :header="{multiple: false, label: 'name'}"
    :selected-val="selectedType"
  />
</template>

<script>
import VsSelect from "../_framework/VsSelect";

export default {
  name: "voucher-type-select",
  props: {
    mode: {
      default: "view",
      type: String
    },
    headerKey: {
      default: "",
      type: String
    },
    isHeader: {
      default: false,
      type: Boolean
    },
    row: {
      default() {
        return {};
      },
      type: Object
    },
    data: null
  },
  components: {
    VsSelect
  },
  data() {
    return {
      show: true,
      _mode: "",
      voucherTypes: [
        {
          name: "ورودی",
          value: 1
        },
        {
          name: "خروجی",
          value: 2
        }
      ],
      selectedType: {}
    };
  },
  beforeMount() {
    this._mode = this.mode;
    if (this.isHeader === false) {
      this._mode = "view";
    } else {
      this._mode = "edit";
    }
    this.selectedType = this.row.type;
  },
  methods: {
    onDataChanged(headerKey, val) {
      val = val ? val.value : null;
      this.$emit("onChange", val);
      this.$emit("dataChanged", headerKey, val);
    },
    refresh() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 50);
    }
  },
  watch: {
    mode(val) {
      this._mode = val;
      this.refresh();
    }
  }
};
</script>